import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static targets = ["chart"]
  static values = {
    url: String
  }

  connect() {
    this.loadChart()
    console.log("connected to the dashboard controller")
  }

  loadChart() {
    fetch(this.urlValue)
      .then(res => res.json())
      .then(data => {
        this.renderChart(data)
      })
  }

  renderChart(data) {
    if (this.chart) {
      this.chart.destroy()
    }

      const sanitizedRate = data.rate.map(val => (val === null || val === undefined ? 0 : val));
      const sanitizedRegistered = data.registered.map(val => val || 0);
      const sanitizedActive = data.active.map(val => val || 0);

      const options = {
        series: [
          {
            name: "登録ユーザー数",
            type: "column",
            data: sanitizedRegistered
          },
          {
            name: "アクティブユーザー数",
            type: "column",
            data: sanitizedActive
          },
          {
            name: "アクティブユーザー率",
            type: "line",
            data: sanitizedRate 
          }
        ],
      chart: {
        height: 350,
        type: "line",
        stacked: false,
        toolbar: false,
        zoom: {
        enabled: false
      }
      },
      stroke: {
        width: [0, 0, 3]
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: data.labels
      },
      yaxis: [
      {
        
        seriesName: "登録ユーザー数", 
        title: {
          text: "ユーザー数"
        },
        min: 0,
        
      },
      {
        
        show: false, 
        seriesName: "登録ユーザー数", 
      },
      {
        
        opposite: true,
        seriesName: "アクティブユーザー率",
        title: {
          text: "割合 (%)"
        },
        min: 0,
        max: 100 
      }
    ],
      colors: ["#3699FF", "#1BC5BD", "#FFA800"]
    }

    this.chart = new ApexCharts(this.chartTarget, options)
    this.chart.render()
  }
}